export const MIME_TYPE_FORM_DATA_MULTIPART = "multipart/form-data";
export const MIME_TYPE_JSON = "application/json";
export const MIME_TYPE_JSON_LD = "application/ld+json";
export const MIME_TYPE_MERGE_PATCH_JSON = "application/merge-patch+json";
export const MIME_TYPE_PDF = "application/pdf";
export const MIME_TYPE_CSV = "text/csv";
export const MIME_TYPE_PLAIN_TEXT = "text/plain";
export const MIME_TYPE_XLS = "application/vnd.ms-excel";
export const MIME_TYPE_XLSX =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const MIME_TYPES = [
  MIME_TYPE_FORM_DATA_MULTIPART,
  MIME_TYPE_JSON,
  MIME_TYPE_JSON_LD,
  MIME_TYPE_MERGE_PATCH_JSON,
  MIME_TYPE_PDF,
  MIME_TYPE_CSV,
  MIME_TYPE_PLAIN_TEXT,
  MIME_TYPE_XLS,
  MIME_TYPE_XLSX,
];
